import './styles.scss';

export const Logo = () => <span className="Logo" />;
